var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.137 10.882a1.25 1.25 0 0 1 0 2.486l-.128.007h-.01a1.25 1.25 0 1 1 0-2.5h.01zM12.133 10.882a1.25 1.25 0 0 1 0 2.486l-.128.007h-.01a1.25 1.25 0 0 1 0-2.5h.01zM18.137 10.882a1.25 1.25 0 0 1 0 2.486l-.128.007h-.01a1.25 1.25 0 0 1 0-2.5h.01z"
  })));
};
export default Svg24;